<template>
    <div class="MessageBoard">

        <van-nav-bar class="nav-bar" :title="$t('留言板')">
            <!-- <template #left>
        <van-icon name="arrow-left" color="#d7d7d7" @click="back()"/>
      </template> -->
        </van-nav-bar>
        <van-pull-refresh style="height: 85vh;"  :immediate-check="false" v-model="isLoading" @refresh="onRefresh" :pulling-text="$t('refresh.pulling')"
            :loosing-text="$t('refresh.loosing')" :loading-text="$t('refresh.loading')">
            <div class="hot-recommend-div">
                <van-empty v-if="msg_list.length === 0" :description="$t('withdraw.empty_data')" />
                <van-list v-else v-model="loading" :finished="finished" :offset="50" :immediate-check="false"
                    :finished-text="$t('video.no_more')" :loading-text="$t('refresh.loading')" @load="onLoad">

                    <div class="MessageBoard_list" v-for="(item,index) in msg_list" :key="index">
                        <div class="MessageBoard_list_item">
                            <div class="MessageBoard_list_item_time">{{ item.add_time | dateFormat }}</div>
                            <div class="MessageBoard_list_item_name">{{ item.nickname  }}</div>
                            <div class="MessageBoard_list_item_content">{{ item.content  }}</div>
                        </div>
                    </div>
                </van-list>

            </div>
        </van-pull-refresh>
    </div>
</template>

<script>

import { Toast } from 'vant';
export default {
    data() {
        return {
            isLoading: false,
            count: 0,
            loading: false,
            finished: false,
            refreshing: false,
            msg_list: [],
            page: 0,
        }
    },

    filters: {
        dateFormat(val) {
            // 先把传参毫秒转化为new Date()
            const dt = new Date(val * 1000)
            const y = dt.getFullYear()
            // 月份是从0开始,需要+1
            // +''是把数字转化为字符串,padStart(2,'0')是把字符串设置为2位数,不足2位则在开头加'0'
            const m = (dt.getMonth() + 1 + '').padStart(2, '0')
            const d = (dt.getDate() + '').padStart(2, '0')
            return `${m}/${d}/${y}`
        }
    },
    methods: {
        back() {
            this.$router.replace('/Home')
        },
        getVideoList() {
            this.$http({
                method: 'get',
                data: {  page: this.page },
                url: 'memberfeedbacklist'
            }).then(res => {
                console.log(res,8888)
                this.loading = false;
                this.isLoading  = false
                this.finished = false;
                this.msg_list = this.msg_list.concat(res.data);
                this.count = res.data.count;
                this.page++;
                
                if (this.msg_list.length < 15) {
                    this.finished = true;
                }

            })
        },
        onLoad() {
            console.log(9999)
            this.loading = true;
            this.getVideoList();
            
        },
        OnChange() {
            this.msg_list = [];
            this.page = 0;
            this.count = 0;
            this.getVideoList();//获取视频列表

        },
        onRefresh() {
                this.page = 0
                this.getVideoList();
                Toast(this.$t("reservation.refresh"));
        },
    },
    created() {
        this.OnChange()
    }
}
</script>

<style scoped>
.MessageBoard {}

.MessageBoard_list {
    border: 1px solid #f2f2f2;
    margin: 20px 30px;
    padding: 30px;
    border-radius: 10px;
}

.MessageBoard_list_item {}

.MessageBoard_list_item_time {
    font-size: 20px;
    margin-bottom: 10px;
    font-weight: bold;
}

.MessageBoard_list_item_name {
    font-size: 26px;
    margin-bottom: 15px;
    color: #999999;
}

.MessageBoard_list_item_content {
    font-size: 24px;
    font-weight: bold;
}


::v-deep .van-pull-refresh {
    height: calc(100vh - 200px) !important; /* 计算高度(减去的高度自己调) */
    overflow: auto !important; /* 滚动自适应 */
}
::v-deep .van-list {
    height: auto !important; /* 列表高度自适应 */
}
</style>